import { BUILD_DATE } from './../../../build';


class TopbarController {
    /**
     * @param {Object} $state
     * @param {Object} userService
     * @param {Object} authService
     */
    constructor($state, userService, authService) {
        this.$state = $state;
        this.userEmail = localStorage.getItem('kes_email');
        this.userService = userService;
        this.authService = authService;
        this.BUILD_DATE = BUILD_DATE;
    }

    handleLogoutClick() {
        this.authService.logout();
    }

    openMyProfile() {
        this.$state.go('user.profile', {id: this.userService.currentUser.id});
    }
}

TopbarController.$inject = ['$state', 'UserService', 'AuthService'];

export default TopbarController;



// WEBPACK FOOTER //
// ./src/app/components/topbar/topbarController.js